import { combineReducers } from 'redux';

// Front
import Layout from './layouts/reducer';

// Authentication
import Login from './auth/login/reducer';
import Account from './auth/register/reducer';
import ForgetPassword from './auth/forgetpwd/reducer';
import Profile from './auth/profile/reducer';

//Calendar
import Calendar from './calendar/reducer';
//Chat
import chat from './chat/reducer';
//Ecommerce
import Ecommerce from './ecommerce/reducer';

//Project
import Projects from './projects/reducer';

// Tasks
import Tasks from './tasks/reducer';
//Form advanced
import changeNumber from './formAdvanced/reducer';

//Crypto
import Crypto from './crypto/reducer';

//TicketsList
import Tickets from './tickets/reducer';
//Crm
import Crm from './crm/reducer';

//Invoice
import Invoice from './invoice/reducer';

//Mailbox
import Mailbox from './mailbox/reducer';

/* ---------------------------- THRIWE-One-Admin ---------------------------- */

// COMMON
import Countries from './application/common/country/reducer';
import Regions from './application/common/region/reducer';
import SubRegions from './application/common/subRegion/reducer';
import Airports from './application/common/airports/reducer';
import BookingTypes from './application/bookings/bookingTypes/reducer';
import DeleteFile from './application/coupon/deleteFile/reducer';

// USER LOGIN
import UserLogin from './application/common/login/reducer';

// USER LOGOUT
import UserLogout from './application/common/logout/reducer';

// Mail
import SendMail from './application/common/mail/reducer';

// All Projects
import AllProjects from './application/common/projects/reducer';

// All Golf Courses
import AllGolfCourses from './application/common/golfcourses/reducer';

/* ---------------------------- COMMON API'S ---------------------------- */
import GetRedemptionType from './application/supplyStore/common/getRedemptionType/reducer';
import GetParentCategory from './application/supplyStore/common/getParentCategory/reducer';
import MainAreaLoader from './application/common/mainAreaLoader/reducer';
import FullScreenLoader from './application/common/fullScreenLoader/reducer';
import PermissionsByProjectId from './application/common/getPermissionByProjectId/reducer';

/* ---------------------------- DASHBOARD ---------------------------- */
import GetSurgeReport from './application/Dashboard/SurgeReport/reducer';
import GetUsersList from './application/Dashboard/UserInfo/reducer';
import GetUserPoints from './application/Dashboard/UserPoints/reducer';
import GetUserBookings from './application/Dashboard/UserBookings/reducer';
import GetMisReport from './application/Dashboard/MisReport/reducer';

/* ---------------------------- SUPPLY STORE ---------------------------- */
import GetUploadsInfo from './application/supplyStore/common/getUploadsInfo/reducer';

// Category
import CreateCategory from './application/supplyStore/category/createCategory/reducer';
import GetCategory from './application/supplyStore/category/listCategory/reducer';
import UpdateCategory from './application/supplyStore/category/updateCategory/reducer';

// Location
import CreateLocation from './application/supplyStore/Location/createLocation/reducer';
import GetLocation from './application/supplyStore/Location/listLocation/reducer';
import UpdateLocation from './application/supplyStore/Location/updateLocation/reducer';

// Partner
import CreatePartner from './application/supplyStore/Partner/createPartner/reducer';
import GetPartners from './application/supplyStore/Partner/listPartner/reducer';
import UpdatePartner from './application/supplyStore/Partner/updatePartner/reducer';

// Service
import CreateService from './application/supplyStore/Service/createService/reducer';
import GetService from './application/supplyStore/Service/listService/reducer';
import UpdateService from './application/supplyStore/Service/updateService/reducer';

/* ---------------------------- COUPON MANAGEMENT ---------------------------- */
import GetCoupon from './application/coupon/getCoupon/reducer';
import GetCoupons from './application/coupon/getCoupons/reducer';
import GetCouponCategory from './application/coupon/category/reducer';
import GetCouponFacility from './application/coupon/facility/reducer';
import GetCouponPartner from './application/coupon/partner/reducer';
import GetCouponProject from './application/coupon/projects/reducer';
import GetCouponServices from './application/coupon/service/reducer';
import GetCouponAssignedStatusList from './application/coupon/assignedStatus/reducer';
import GetCouponUploadedByList from './application/coupon/uploadedBy/reducer';
import PostCoupons from './application/coupon/uploadCoupons/reducer';
import AssignCoupon from './application/coupon/AssignCoupon/reducer';
import UpdateCoupon from './application/coupon/UpdateCoupon/reducer';
import UploadStaticCoupon from './application/coupon/uploadStaticCoupon/reducer';
import GetStaticCoupons from './application/coupon/getStaticCoupon/reducer';
import UpdateStaticCoupon from './application/coupon/UpdateStaticCoupon/reducer';

/* ---------------------------- BOOKING MANAGEMENT ---------------------------- */
import Bookings from './application/bookings/bookingList/reducer';
import UpdateBooking from './application/bookings/updateBooking/reducer';
import ResendMail from './application/bookings/resendMail/reducer';
import VendorsList from './application/bookings/getVendorsList/reducer';
import GetVendorByBooking from './application/bookings/getVendor/reducer';
import ViewFile from './application/bookings/viewFile/reducer';

/* ---------------------------- CUSTOMER MANAGEMENT ---------------------------- */
import AllRights from './application/common/userRights/reducer';
import CreateUser from './application/common/createUser/reducer';
import ProgramUsers from './application/CustomerManagement/programsUser/reducer';
import MembershipDetails from './application/CustomerManagement/membershipDetails/reducer';
import CardDetails from './application/CustomerManagement/CardDetails/reducer';
import UpdateCustomer from './application/CustomerManagement/UpdateCustomer/reducer';

/* ---------------------------- DUPLICATE CARD MANAGEMENT ---------------------------- */
import DuplicateCards from './application/DuplicateCardManagement/DuplicateCardList/reducer';

/* ---------------------------- BENEFIT MANAGEMENT ---------------------------- */
import BenefitGroups from './application/common/benefitGroups/reducer';
import BenefitPack from './application/Benefits/BenefitPackList/reducer';
import Clients from './application/common/Clients/reducer';
import CreateBenefitPack from './application/Benefits/CreateBenefitPack/reducer';
import BenefitPackInfo from './application/Benefits/BenefitPackInfo/reducer';
import UpdateBenefitPack from './application/Benefits/UpdateBenefitPack/reducer';
import CreateInventoryQuota from './application/Benefits/CreateInventoryQuota/reducer';
import GetInventoryQuota from './application/Benefits/GetInventoryQuota/reducer';
import GetWorkflowsList from './application/Benefits/GetWorkflowsList/reducer';

/* ---------------------------- DOWNLOADS ---------------------------- */
import DownloadsList from './application/Downloads/DownloadList/reducer';
import DownloadDump from './application/Downloads/DownloadDump/reducer';

/* ---------------------------- BLOCK DATE MANAGEMENT ---------------------------- */
import CreateBlockDate from './application/BlockDate/CreateBlockDate/reducer';
import ApprovalBlockDate from './application/V2/GolfPricing/ApprovalActionBlockDate/reducer';
import ApprovalFacilityHoliday from './application/V2/GolfPricing/ApprovalActionFacilityHoliday/reducer';
import BlockedDatesList from './application/BlockDate/ListBlockDate/reducer';
import GetServiceOnFacility from './application/BlockDate/ServicesBasedOnFacility/reducer';
import DeactivateBlockDate from './application/BlockDate/DeactivateBlockDate/reducer';

/* ---------------------------- RULES MANAGEMENT ---------------------------- */
import CreateExpenditureRule from './application/RulesManagement/Expenditure/CreateExpenditureRule/reducer';
import ExpenditureRulesList from './application/RulesManagement/Expenditure/ListExpenditure/reducer';
import UpdateExpenditureRule from './application/RulesManagement/Expenditure/UpdateExpenditureRule/reducer';
import DeleteExpenditureRule from './application/RulesManagement/Expenditure/DeleteExpenditureRule/reducer';

import CreateEventRules from './application/RulesManagement/Event/CreateEventRule/reducer';
import CreateEventRulesWithUserIds from './application/RulesManagement/Event/CreateEventRuleWithUserIds/reducer';
import CreateEventRulesBenefitGroupId from './application/RulesManagement/Event/CreateEventRuleWithBenefitGroupId/reducer';
import EventRulesList from './application/RulesManagement/Event/ListEvent/reducer';
import UpdateEventRule from './application/RulesManagement/Event/UpdateEventRule/reducer';
import DeleteEventRule from './application/RulesManagement/Event/DeleteEventRule/reducer';

import CreateServiceWorth from './application/RulesManagement/ServiceWorth/CreateServiceWorth/reducer';
import ServiceWorthList from './application/RulesManagement/ServiceWorth/ListServiceWorth/reducer';
import UpdateServiceWorth from './application/RulesManagement/ServiceWorth/UpdateServiceWorth/reducer';
import DeleteServiceWorth from './application/RulesManagement/ServiceWorth/DeleteServiceWorth/reducer';

/* ---------------------------- GOLF ADMIN ---------------------------- */
import GetGolfCourseFormatById from './application/GolfAdmin/getGolfCourseFormatById/reducer';
import GetGolfCourseFormats from './application/GolfAdmin/getGolfCourseFormats/reducer';
import deleteGolfCourseFormatById from './application/GolfAdmin/deleteGolfCourseFormatById/reducer';
import GetGolfCourseUnavailable from './application/GolfAdmin/getGolfCourseUnavailable/reducer';
import createGolfCourseSlot from './application/GolfAdmin/createGolfCourseSlot/reducer';
import GetGolfCourses from './application/GolfAdmin/golfCourses/reducer';
import GolfCourseSlots from './application/GolfAdmin/getGolfCourseSlots/reducer';
import DownloadExcelReport from './application/GolfAdmin/getGolfCourseFormatById/reducer';
import DisableGolfCourseUnavailability from './application/GolfAdmin/disableGolfCourseUnavailablility/reducer';
import createGolfCourseUnavailability from './application/GolfAdmin/createGolfCourseUnavailablility/reducer';
import UpdateGolfCourseSlots from './application/GolfAdmin/updateGolfCourseSlots/reducer';

/* ---------------------------- USER MANAGEMENT ---------------------------- */
import Users from './application/UsersMangement/GetUsers/reducer';
import Permissions from './application/UsersMangement/GetPermissions/reducer';
import UpdatePermissions from './application/UsersMangement/UpdatePermissions/reducer';
import BulkUsers from './application/CustomerManagement/GetBulkUsers/reducer';
import UserCards from './application/CustomerManagement/GetUserCards/reducer';
import UpdateUserCard from './application/CustomerManagement/UpdateUserCard/reducer';
import Memberships from './application/CustomerManagement/GetMemberships/reducer';
import GetUserDetails from './application/CustomerManagement/GetUserDetails/reducer';

/* ---------------------------- PROJECT MANAGEMENT ---------------------------- */
import CreateProject from './application/ProjectManagement/CreateProject/reducer';
import ProjectsList from './application/ProjectManagement/ProjectsList/reducer';
import GetPaymentGateways from './application/ProjectManagement/GetPaymentGateways/reducer';
import GetPaymentsList from './application/ProjectManagement/GetPaymentsList/reducer';
import CreatePayment from './application/ProjectManagement/CreatePayment/reducer';
import UpdatePayment from './application/ProjectManagement/UpdatePayment/reducer';
import BinsList from './application/ProjectManagement/ListBins/reducer';
import UpdateBins from './application/ProjectManagement/UpdateBins/reducer';
import CreateBin from './application/ProjectManagement/CreateBins/reducer';
import PaymentLogs from './application/ProjectManagement/PaymentLogs/reducer';
import CreateClient from './application/ProjectManagement/CreateClient/reducer';
import CreateParentProject from './application/ProjectManagement/CreateParentProject/reducer';
import ParentProjects from './application/ProjectManagement/GetParentProjects/reducer';
import UpdateParentProject from './application/ProjectManagement/UpdateParentProject/reducer';
import UpdateProject from './application/ProjectManagement/UpdateProject/reducer';
import UpdateClient from './application/ProjectManagement/UpdateClient/reducer';

/* ---------------------------- CONFIG STORE MANAGEMENT ---------------------------- */
import CreateBenefitGroup from './application/ConfigStoreManagement/BenefitGroup/reducer';
import CreateBenefitGroupItems from './application/ConfigStoreManagement/BenefitGroupItem/reducer';
import BenefitGroupCategories from './application/ConfigStoreManagement/BenefitGroupCategories/reducer';
import CreateBenefitGroupCategory from './application/ConfigStoreManagement/CreateBenefitGroupCategory/reducer';
import GetBenefitGroups from './application/ConfigStoreManagement/BenefitGroupsList/reducer';
import GetServicesInBenefitItem from './application/ConfigStoreManagement/Service/reducer';
import UpdateBenefitGroup from './application/ConfigStoreManagement/UpdateBenefitGroup/reducer';
import UpdateBenefitGroupItems from './application/ConfigStoreManagement/UpdateBenefitGroupItems/reducer';
import GetBenefitGroupItemsList from './application/ConfigStoreManagement/BenefitGroupItemsList/reducer';
import BenefitItemsList from './application/ConfigStoreManagement/BenefitItemsList/reducer';
import UpdateBenefitItems from './application/ConfigStoreManagement/UpdateItems/reducer';

/* ---------------------------- CUSTOMER DATA MANAGEMENT ---------------------------- */
import CustomerUploadsInfo from './application/CustomerDataManagement/CustomerUploadsInfo/reducer';
import ClientsCustomer from './application/CustomerDataManagement/ClientsCustomer/reducer';
import UpdateClientsCustomer from './application/CustomerDataManagement/UpdateClientsCustomer/reducer';

/* ----------------------------------- SURGE SPHERE ----------------------------------- */
// CAMPAIGN
import CreateCampaign from './application/SurgeSphere/Campaign/createCampaign/reducer';
import GetCampaigns from './application/SurgeSphere/Campaign/listCampaign/reducer';
import UpdateCampaign from './application/SurgeSphere/Campaign/updateCampaign/reducer';

// RULES
import CreateRule from './application/SurgeSphere/Rules/createRule/reducer';
import GetRules from './application/SurgeSphere/Rules/listRule/reducer';
import UpdateRule from './application/SurgeSphere/Rules/updateRule/reducer';
import DeleteRule from './application/SurgeSphere/Rules/deleteRule/reducer';

// EVENTS
import CreateEvent from './application/SurgeSphere/Event/createEvent/reducer';
import GetEvents from './application/SurgeSphere/Event/listEvent/reducer';
import UpdateEvent from './application/SurgeSphere/Event/updateEvent/reducer';
import DeleteEvent from './application/SurgeSphere/Event/DeleteEvent/reducer';

// ATTRIBUTES
import CreateAttribute from './application/SurgeSphere/Attributes/createAttribute/reducer';
import GetAttributes from './application/SurgeSphere/Attributes/listAttribute/reducer';
import UpdateAttribute from './application/SurgeSphere/Attributes/updateAttribute/reducer';
import DeleteAttribute from './application/SurgeSphere/Attributes/deleteAttribute/reducer';

// WALLETS
import GetWallets from './application/SurgeSphere/Wallet/walletsList/reducer';

/* ----------------------------------- DATA POOL ----------------------------------- */
import FilesSummary from './application/DataPool/GetFilesSummary/reducer';
import FileSummary from './application/DataPool/GetFileRowSummary/reducer';
import UploadFile from './application/DataPool/UploadData/reducer';

/* ----------------------------------- DATA INTEGRATION ----------------------------------- */
import IntegrationData from './application/ProjectManagement/GetIntegrationData/reducer';
import UpdateIntegrationData from './application/ProjectManagement/UpdateIntegrationData/reducer';
import CreateIntegrationData from './application/ProjectManagement/CreateDataIntegration/reducer';

/* ----------------------------------- COMMUNICATION ----------------------------------- */
import CreateTemplate from './application/Communication/CreateTemplate/reducer';
import GetTemplates from './application/Communication/TemplateList/reducer';
import UpdateTemplate from './application/Communication/UpdateTemplate/reducer';
import CreateComsConfig from './application/Communication/CreateComsConfig/reducer';
import UpdateComsConfig from './application/Communication/UpdateComsConfig/reducer';
import GetComsConfig from './application/Communication/ComsConfigList/reducer';
import GetComsEvents from './application/Communication/ComsEventList/reducer';
import GetTemplateDetails from './application/Communication/TemplateList/reducer';
import CreateComsChannelConfig from './application/Communication/CreateComsChannel/reducer';
import UpdateComsChannelConfig from './application/Communication/UpdateComsChannel/reducer';
import GetComsChannelConfig from './application/Communication/GetComsChannel/reducer';
import GetComsBenefit from './application/Communication/GetComsBenefit/reducer';
import GetVariables from './application/Communication/Variables/reducer';
import SendCommunication from './application/Communication/SendCommunication/reducer';

/* ----------------------------------- DASHBOARD ----------------------------------- */
import GetBookingSummary from './application/Dashboard/BookingSummary/reducer';

/* ----------------------------------- THRIWE PRIME BOOKING ----------------------------------- */
import ThriwePrimeBookingList from './application/bookings/thriwePrimeBooking/reducer';

/* ----------------------------------- REPORTS MANAGEMENT ----------------------------------- */
import GetCommsReport from './application/Reports/CommsReport/reducer';

/* ----------------------------------- VENDOR PANEL MANAGEMENT ----------------------------------- */
import GetVendors from './application/VendorPanel/VendorsList/reducer';
import CreateVendor from './application/VendorPanel/CreateVendor/reducer';
import GetBenefitDomains from './application/VendorPanel/BenefitDomainsList/reducer';
import CreateVendorAgent from './application/VendorPanel/CreateVendorAgent/reducer';

/* ----------------------------------- UPDATE MEMBERSHIP ----------------------------------- */
import UpdateMembership from './application/CustomerManagement/UpdateBenefitPack/reducer';

/* ----------------------------------- CLIENT PANEL MANAGEMENT ----------------------------------- */
import ClientLogin from './application/Client/ClientLogin/reducer';
import ValidateToken from './application/Client/ValidateToken/reducer';
import ClientForgotPassword from './application/Client/ForgotPassword/reducer';
import ClientResetPassword from './application/Client/ResetPassword/reducer';
import CreateBooking from './application/Client/CreateBooking/reducer';
import UpdateProfile from './application/Client/UpdateProfile/reducer';
import GetMembershipsData from './application/Client/GetMembershipsData/reducer';
import GetBenefitItems from './application/Client/GetBenefitItem/reducer';
import GetBinsList from './application/Client/GetBins/reducer';
import CreateClientUser from './application/Client/CreateUser/reducer';
import GetClientHistoryList from './application/Client/History/reducer';
import GetClientBenefitConfig from './application/Client/GetBenefitConfig/reducer';
import GetClientAirport from './application/Client/GetClientAirport/reducer';
import ClientDownloadsList from './application/Client/DownloadList/reducer';
import ClientDownloadDump from './application/Client/DownloadDump/reducer';
import SendEmail from './application/Client/SendEMail/reducer';
import ClientRegions from './application/Client/subRegion/reducer';
import GetProjectUtility from './application/Client/ProjectUtility/reducer';

import GetBusiness from './application/Client/GetBusiness/reducer';
import UpdateBusiness from './application/Client/UpdateBusiness/reducer';
import GetQuestionAnswer from './application/Client/GetQuestionAnswer/reducer';
import GetPost from './application/Client/GetPost/reducer';
import UpdatePost from './application/Client/UpdatePost/reducer';
import GetOffer from './application/Client/GetOffer/reducer';
import UpdateOffer from './application/Client/UpdateOffer/reducer';
import AskQuestion from './application/Client/AskQuestion/reducer';
import GetAnnouncements from './application/Client/GetAnnouncements/reducer';
import CreateAnnoucement from './application/Client/PostAnnouncement/reducer';
import GetPostTypes from './application/Client/GetPostTypes/reducer';
import PostImage from './application/Client/UploadImage/reducer';
import AdibSurgeReport from './application/Client/SurgeReport/reducer';
import GetAdibMonthlySummary from './application/Client/GetMonthlySummary/reducer';
import GetAdibPartnersMonthlySummary from './application/Client/GetPartnerMonthlySummary/reducer';
import GetClientCustomers from './application/Client/Customers/reducer';
import DownloadBookingsDump from './application/Client/DownloadBookings/reducer';
import DownloadBookingsInfo from './application/Client/DownloadsInfo/reducer';
import DownloadAdibBookingDump from './application/Client/DownloadAdibBookings/reducer';
import GetPostSetting from './application/Client/GetPostSetting/reducer';
import UpdatePostSetting from './application/Client/UpdatePostSetting/reducer';
import UpdateUserSetting from './application/Client/UpdateUserSetting/reducer';
import ClientDownloadDumpADIB from './application/Client/DownloadInfoAdib/reducer';
import GetClientUser from './application/Client/ClientUsers/reducer';
import GetClientRoleForUser from './application/Client/GetClientRoleForUser/reducer';
import UpdateClientRole from './application/Client/UpdateRole/reducer';
import GetClientRole from './application/Client/GetClientRole/reducer';
import CreateAdibClient from './application/Client/CreateAdibClient/reducer';
import GetClientPermissionForUser from './application/Client/GetPermissionForUser/reducer';
import UpdateUserStatus from './application/Client/UpdateUserStatus/reducer';
import GetAdibDashboard from './application/Client/AdibDashboard/reducer';
import DownloadUserLogs from './application/Client/DownloadUserLogs/reducer';
import DownloadUserReport from './application/Client/DownloadUserReport/reducer';
import GetUserDownloads from './application/Client/UserDownloads/reducer';

/* ----------------------------------- AIRPORT TRANSFER MANUAL BOOKING ----------------------------------- */
import GetAdminMembershipsData from './application/bookings/GetMembershipData/reducer';
import GetBenefitCategory from './application/bookings/GetBenefitCategory/reducer';
import GetUserCardData from './application/bookings/GetUserCards/reducer';
import GetMembershipQuota from './application/bookings/GetMembershipQuota/reducer';
import CreateManualBooking from './application/bookings/CreateManualBooking/reducer';
import GetAdminBenefitItems from './application/bookings/GetBenefitItem/reducer';
import CreateUploadTicket from './application/bookings/UploadTicket/reducer';

/* ----------------------------------- VENDOR ----------------------------------- */
import VendorLogin from './application/Vendor/Login/reducer';
import GetVendorsList from './application/VendorPanel/VendorsList/reducer';
import GetVendorsDashboardData from './application/Vendor/Dashboard/reducer';
import GetVendorBookings from './application/Vendor/VendorBookings/reducer';
import VendorDownloadDump from './application/Vendor/DownloadDump/reducer';
import VendorDownloadsList from './application/Vendor/DownloadList/reducer';
import VendorUpdateBooking from './application/Vendor/UpdateVendorBookings/reducer';
import VendorOtpValidate from './application/Vendor/ValidateOtp/reducer';
import VendorResendOtp from './application/Vendor/ResendOtp/reducer';
import VendorGenerateQr from './application/Vendor/GenerateQr/reducer';
import GetUserProfile from './application/Vendor/GetProfile/reducer';
import VendorBookingUpdate from './application/Vendor/VendorBookingUpdate/reducer';
import ValidateUser from './application/CustomerManagement/ValidateUser/reducer';

/* ----------------------------------- BOOKING TYPE V2 ----------------------------------- */
import BookingsV2 from './application/Bookings_V2/BookingList/reducer';
import ConfirmBookingV2 from './application/Bookings_V2/ConfirmBooking/reducer';
import CancelBookingV2 from './application/Bookings_V2/CancelBooking/reducer';
import ProccessBookingV2 from './application/Bookings_V2/ProccessBooking/reducer';
import CompleteBookingV2 from './application/Bookings_V2/CompleteBooking/reducer';
import CancelBookingGolf from './application/Bookings_V2/Golf/CancelBooking/reducer';
import ConfirmBookingGolf from './application/Bookings_V2/Golf/ConfirmBooking/reducer';
import DownloadDumpV2 from './application/Bookings_V2/DownloadBooking/reducer';
import DwonloadListV2 from './application/Bookings_V2/DownloadList/reducer';

/* ----------------------------------- PERMISSION CHECKER ----------------------------------- */
import PermissionChecker from './application/common/permission-checker/reducer';
import UpdatePermissionRequest from './application/common/UpdateRequestStatus/reducer';
import BookingsSearch from './application/bookings/bookingSearch/reducer';

/* ----------------------------------- GM REPORT ----------------------------------- */
import GetFileTypes from './application/GmReport/GetFileTypes/reducer';
import GetFileTypesConfig from './application/GmReport/GetFileTypesConfig/reducer';
import GetRecordData from './application/GmReport/GetRecordData/reducer';
import GetTrackerData from './application/GmReport/GetTrackerData/reducer';
import UploadConfigExcel from './application/GmReport/UploadExcel/reducer';
import DownloadExcel from './application/GmReport/DownloadExcel/reducer';
import UpdateRecordData from './application/GmReport/UpdateRecord/reducer';
import PublishRecord from './application/GmReport/PublishRecord/reducer';
import ApproveRejectRecords from './application/GmReport/ApproveReject/reducer';
import SendApprovalMail from './application/GmReport/SendMail/reducer';
import DeleteTrackerRecord from './application/GmReport/DeleteTrackerRecord/reducer';
import GetClientPrice from './application/GmReport/GetClientPrice/reducer';
import GetAmenitiesDetails from './application/GmReport/Amenities/reducer';
import GetPriceDetails from './application/GmReport/GetPriceDetails/reducer';
import PublishDataWithAuth from './application/GmReport/PublishDataWithAuth/reducer';
import PricePreview from './application/GmReport/PricePreview/reducer';
import UploadAttachment from './application/GmReport/UploadAttachment/reducer';
import DeleteAttachment from './application/GmReport/DeleteAttachment/reducer';
import GetReconDetails from './application/GmReport/GetReconDetails/reducer';
import GetGmReport from './application/GmReport/GetGmReport/reducer';
import GetReconPreview from './application/GmReport/GetReconPreview/reducer';

/* ----------------------------------- SURGE V2 ----------------------------------- */
// RULES
import CreateSurgeRule from './application/Surge-v2/Rules/CreateRule/reducer';
import CreateSurgeWorkflow from './application/Surge-v2/Rules/CreateSurgeWorkflow/reducer';
import GetSurgeRulesList from './application/Surge-v2/Rules/ListRules/reducer';
import ListSurgeRuleTables from './application/Surge-v2/Rules/ListRuleTables/reducer';

// REFERRAL
import GetReferral from './application/Surge-v2/Referral/GetReferral/reducer';
import ValidateReferral from './application/Surge-v2/Referral/ValidateReferral/reducer';
import GetLedger from './application/Surge-v2/Ledger/GetLedger/reducer';

// EVENTS
import ListSurgeEvents from './application/Surge-v2/Events/ListEvents/reducer';
import GetUserRegistration from './application/Surge-v2/UserRegistration/GetUserRegistration/reducer';
import UserRegistration from './application/Surge-v2/UserRegistration/UploadFile/reducer';

// EFFECTS
import ListSurgeEffects from './application/Surge-v2/Effects/ListEffects/reducer';
import GetSampleFile from './application/Surge-v2/UserRegistration/GetSampleFile/reducer';

// VOUCHER
import GetVoucherBooking from './application/Surge-v2/Voucher/VoucherBooking/reducer';
import GetVoucherBookingDetails from './application/Surge-v2/Voucher/VoucherBookingDetails/reducer';
import ValidateVoucher from './application/Surge-v2/Voucher/ValidateVoucherBooking/reducer';
import ChaufferAssign from './application/Bookings_V2/ChaufferAssignV2/reducer';

// GLOBE TOYOTA V2
import GetAnnouncementForGlobe from './application/Surge-v2/Announcement/GetAnnouncement/reducer';
import CreateAnnouncementForGlobeToyota from './application/Surge-v2/Announcement/CreateAnnouncement/reducer';
import UpdateAnnouncementForGlobeToyota from './application/Surge-v2/Announcement/UpdateAnnoucement/reducer';
import GetTemplateList from './application/Surge-v2/Rules/ListTemplate/reducer';
import TemplateDetails from './application/Surge-v2/Rules/TemplateDetails/reducer';
import RuleDetails from './application/Surge-v2/Rules/RuleDetails/reducer';
import CreateTemplateWorkflow from './application/Surge-v2/Rules/CreateTemplateWorkflow/reducer';
import CreateTemplateMapping from './application/Surge-v2/Rules/CreateTemplateMapping/reducer';
import GetRuleDashboard from './application/Surge-v2/GetRuleDashboard/reducer';
import GetDownloadLedgers from './application/Surge-v2/DownloadLedgers/reducer';
import GetDownloadVouchers from './application/Surge-v2/DownloadVouchers/reducer';
import getDownloadReferrals from './application/Surge-v2/DownloadReferrals/reducer';

import UserLoginV2 from './application/common/loginV2/reducer';
import UserToken from './application/V2/UserToken/reducer';
import VendorLoginV2 from './application/common/VendorLoginV2/reducer';

import AssignChauffeur from './application/V2/Bookings/AirportTransfer/AssignChauffeur/reducer';
import BookingAssignToMe from './application/V2/Bookings/AirportTransfer/AssignToMe/reducer';
import AssignVendor from './application/V2/Bookings/AirportTransfer/AssignVendor/reducer';
import CancelBookingByVendor from './application/V2/Bookings/AirportTransfer/CancelBookingByVendor/reducer';
import ConfirmBookingByVendor from './application/V2/Bookings/AirportTransfer/ConfirmBookingByVendor/reducer';
import CreateChauffeur from './application/V2/Bookings/AirportTransfer/CreateChauffeur/reducer';
import GetChauffersList from './application/V2/Bookings/AirportTransfer/GetChauffeursList/reducer';
import GetCarsListOfVendor from './application/V2/Bookings/AirportTransfer/GetCarsListOfVendor/reducer';
import GetVendorsListData from './application/V2/Bookings/AirportTransfer/GetVendorsList/reducer';
import GetBookingsList from './application/V2/Bookings/AirportTransfer/GetBookingsList/reducer';
import GetBookingDetails from './application/V2/Bookings/AirportTransfer/GetBookingDetails/reducer';
import GetDigitalOffers from './application/V2/DigitalBookingManagement/GetDigitalOffers/reducer';
import GetDigitalAuthMethods from './application/V2/DigitalBookingManagement/GetDigitalAuthMethods/reducer';
import GetDigitalCardStates from './application/V2/DigitalBookingManagement/GetDigitalCardStates/reducer';
import CreateOutlet from './application/V2/OutletManagement/CreateOutlet/reducer';
import GetOutlets from './application/V2/OutletManagement/GetOutlets/reducer';
import GetOutletDetails from './application/V2/OutletManagement/GetOutletDetails/reducer';
import GetOutletStatusCounts from './application/V2/OutletManagement/GetOutletStatusCounts/reducer';
import UpdateOutlet from './application/V2/OutletManagement/UpdateOutlet/reducer';
import GetOutletFilters from './application/V2/ValidationManagement/GetOutletFilters/reducer';
import VerifyCoupon from './application/V2/ValidationManagement/VerifyCoupon/reducer';
import GetFiltersList from './application/V2/Bookings/AirportTransfer/GetFiltersList/reducer';
import GetFilterValues from './application/V2/Bookings/AirportTransfer/GetFilterValues/reducer';
import CancellationRemarksForVendor from './application/V2/Bookings/AirportTransfer/CancellationRemarksForVendor/reducer';
import AssignVendorRemarksList from './application/V2/Bookings/AirportTransfer/AssignVendorRemarksList/reducer';
import NudgeDriver from './application/V2/Bookings/AirportTransfer/NudgeDriver/reducer';
import GetAvailableVehicles from './application/V2/Bookings/AirportTransfer/GetAvailableVehicles/reducer';
import ChangeVehicle from './application/V2/Bookings/AirportTransfer/ChangeVehicle/reducer';
import BookingType from './application/V2/BookingType/reducer';
import ChangeActivity from './application/V2/ChangeActivity/reducer';
import V2Dashboard from './application/V2/Dashboard/reducer';
import UserRoles from './application/V2/UserRole/reducer';
import CancelBookingByAdmin from './application/V2/Bookings/AirportTransfer/CancelBookingByAdmin/reducer';
import FetchActivity from './application/V2/FetchActivity/reducer';
import GetDashboardConfiguration from './application/V2/GetDashboardConfiguration/reducer';
import GetCardSummary from './application/V2/GetCardSummary/reducer';
import GetBookingTypeForGlobalSearch from './application/V2/Bookings/GetBookingType/reducer';
import GetBookingGlobalSearch from './application/V2/Bookings/GetGlobalSearchBooking/reducer';
import ShowModifyField from './application/V2/Bookings/AirportTransfer/ModifyFields/reducer';
import ModifyBooking from './application/V2/Bookings/AirportTransfer/ModifyBooking/reducer';
import ApprovalActionBooking from './application/V2/Bookings/AirportTransfer/ApprovalAction/reducer';
import RemarkStatusDetails from './application/V2/DynamicReason/GetRemarkStatus/reducer';
import GetActionByStatus from './application/V2/DynamicReason/GetActionByStatus/reducer';
import GetReasonByActions from './application/V2/DynamicReason/GetReason/reducer';
import AddReason from './application/V2/DynamicReason/AddReason/reducer';
import UpdateReason from './application/V2/DynamicReason/UpdateReason/reducer';
import GetVendorDetails from './application/V2/AirportClientPricing/GetVendorDetails/reducer';
import CompleteBooking from './application/V2/Bookings/AirportTransfer/CompleteBooking/reducer';
import RaiseDispute from './application/V2/Bookings/AirportTransfer/RaiseDispute/reducer';
import GetBookingDumpTypeList from './application/V2/GetBookingDumpTypeList/reducer';
import PostDownloadDumpAdminV2 from './application/V2/DownloadDump/reducer';
import GetDownloadDumpList from './application/V2/GetDownloadDumpList/reducer';
import BulkBookingConfirmationByVendor from './application/V2/Bookings/AirportTransfer/BulkBookingConfirm/reducer';

import GetAirportsBasedOnConfig from './application/V2/AirportTransferBooking/Airports/reducer';
import getAutoCompleteLocation from './application/V2/AirportTransferBooking/AutoCompleteLocation/reducer';
import CreateAirportTransferBooking from './application/V2/AirportTransferBooking/CreateAirportTransferBooking/reducer';
import CreateGuestUser from './application/V2/AirportTransferBooking/CreateGuestUser/reducer';
import GetBookingSummaryData from './application/V2/AirportTransferBooking/GetBookingSummary/reducer';
import GetGuestUsers from './application/V2/AirportTransferBooking/GetGuestUsers/reducer';
import GetValidateFlightDetails from './application/V2/AirportTransferBooking/ValidateFlightDetails/reducer';
import GetRecentSearches from './application/V2/AirportTransferBooking/RecentSearches/reducer';
import UpdateGuestUser from './application/V2/AirportTransferBooking/UpdateGuestUser/reducer';
import GetValidateLocation from './application/V2/AirportTransferBooking/ValidateLocation/reducer';
import GetPaymentSummary from './application/V2/AirportTransferBooking/GetPaymentSummary/reducer';
import ValidateOTP from './application/V2/Bookings/AirportTransfer/ValidateOTP/reducer';
import ResendOTP from './application/V2/Bookings/AirportTransfer/ResendOTP/reducer';
import SendNotificationByAdmin from './application/V2/Bookings/SendNotification/reducer';
import GetNotificationBooking from './application/V2/Bookings/Golf/GetNotificationBooking/reducer';
import GetNotificationStatus from './application/V2/Bookings/Golf/GetNotificationStatus/reducer';
import GetSidebarConfiguration from './application/V2/GetSidebarConfiguration/reducer';
import GetRejectSlotOptions from './application/V2/Bookings/Golf/RejectSlotOptions/reducer';
import RejectSlot from './application/V2/Bookings/Golf/RejectSlot/reducer';
import MarkNoShow from './application/V2/Bookings/Golf/MarkNoShow/reducer';
import AddManualPricing from './application/V2/Bookings/ManualPricing/reducer';
import CreateSpinGame from './application/Surge-v2/Gamification/CreateSpinGame/reducer';
import GetBenefitsGamification from './application/Surge-v2/Gamification/GetBenefitsGamification/reducer';
import GetBenefitsGamificationPoint from './application/Surge-v2/Gamification/GetBenefitsGamificationPoints/reducer';
import GetGamificationList from './application/Surge-v2/Gamification/GetGamificationList/reducer';
import UpdateGameStatus from './application/Surge-v2/Gamification/UpdateGameStatus/reducer';
import GetFeedbackList from './application/Surge-v2/Feedback/GetFeedback/reducer';
import CreateQuizGame from './application/Surge-v2/Gamification/CreateQuiz/reducer';
import GetTrendingUser from './application/Surge-v2/Dashboard/GetDashboard/reducer';
import GetBenefitGroup from './application/Client/GetBenefitGroup/reducer';
import SuggestGolf from './application/V2/Bookings/AirportTransfer/SuggestGolf/reducer';
import AddSuggestGolf from './application/V2/Bookings/AirportTransfer/AddSuggestGolf/reducer';
import CompleteBookingGolf from './application/V2/Bookings/AirportTransfer/CompleteBookingGolf/reducer';
import GetRejectSlotOptionsV2 from './application/V2/Bookings/Golf/RejectSlotOptionsV2/reducer';

// Airport Transfer Client Pricing
import GetClientV2 from './application/V2/AirportClientPricing/GetClient/reducer';
import GetCoordinates from './application/V2/AirportClientPricing/GetCoordinate/reducer';
import GetProjectV2 from './application/V2/AirportClientPricing/GetProject/reducer';
import GetBenefitAndBenefitGroup from './application/V2/AirportClientPricing/GetBenefitAndBenefitGroup/reducer';
import GetCarType from './application/V2/AirportClientPricing/GetCarType/reducer';
import GetClientDetailsV2 from './application/V2/AirportClientPricing/GetClientDetails/reducer';
import GetInventoryView from './application/V2/AirportClientPricing/InventoryView/reducer';
import CreateClientV2 from './application/V2/AirportClientPricing/CreateClient/reducer';
import CreateZonesV2 from './application/V2/AirportClientPricing/CreateZones/reducer';
import CreateVendorV2 from './application/V2/AirportClientPricing/CreateVendor/reducer';
import ChangeVendorPassword from './application/V2/AirportClientPricing/ChangeVendorPassword/reducer';
import CreateAirportV2 from './application/V2/AirportClientPricing/CreateAirport/reducer';
import UpdateClientV2 from './application/V2/AirportClientPricing/UpdateClient/reducer';
import UpdateZonesV2 from './application/V2/AirportClientPricing/UpdateZones/reducer';
import UpdateVendorV2 from './application/V2/AirportClientPricing/UpdateVendor/reducer';
import UpdateVendorStatusV2 from './application/V2/AirportClientPricing/UpdateVendorStatus/reducer';
import UpdateAirportV2 from './application/V2/AirportClientPricing/UpdateAirport/reducer';
import SaveDraftConfiguration from './application/V2/AirportClientPricing/SaveAsDraft/reducer';
import UpdateDraftConfiguration from './application/V2/AirportClientPricing/UpdateAsDraft/reducer';
import DownloadPriceType from './application/V2/AirportClientPricing/DownloadPriceFile/reducer';
import UploadPriceType from './application/V2/AirportClientPricing/UploadPriceFile/reducer';
import GetOnboardingConfiguration from './application/V2/AirportClientPricing/GetOnboardingConfiguration/reducer';
import ApprovalActionConfiguration from './application/V2/AirportClientPricing/ApprovalActionConfiguration/reducer';
import GetLiveConfig from './application/V2/AirportClientPricing/GetLiveConfig/reducer';
import PublishConfiguration from './application/V2/AirportClientPricing/PublishConfiguration/reducer';
import PublishApproval from './application/V2/AirportClientPricing/PublishApproval/reducer';
import ValidateZone from './application/V2/AirportClientPricing/ValidateZone/reducer';
import GetPolygonRegion from './application/V2/AirportClientPricing/GetPolygonRegion/reducer';
import RevokeConfiguration from './application/V2/AirportClientPricing/RevokeConfiguration/reducer';
import GetVendorList from './application/V2/AirportClientPricing/GetVendor/reducer';
import GetProjectList from './application/V2/AirportClientPricing/GetProjectList/reducer';
import CancelledWithVendor from './application/V2/Bookings/Golf/CancelledWithVendor/reducer';
import UploadCancelationFile from './application/V2/Bookings/Golf/UploadCancelationFile/reducer';
import ViewPricing from './application/V2/AirportClientPricing/ViewPricing/reducer';
import DownloadPricing from './application/V2/AirportClientPricing/DownloadPricing/reducer';
import VendorUnAssigned from './application/V2/Bookings/AirportTransfer/VendorUnassigned/reducer';
import GetLiveBenefitGroup from './application/V2/AirportClientPricing/GetLiveBenefitGroup/reducer';

// Customer 360
import CustomerVerification from './application/V2/Customer360/CustomerVerify/reducer';
import CustomerSession from './application/V2/Customer360/CustomerSession/reducer';
import CustomerUserDetail from './application/V2/Customer360/CustomerUserDetail/reducer';
import GetCustomerIssues from './application/V2/Customer360/GetCustomerIssues/reducer';
import GetCustomerResolutions from './application/V2/Customer360/GetCustomerResolutions/reducer';
import GetIssueLog from './application/V2/Customer360/GetIssueLog/reducer';
import ExecuteResolution from './application/V2/Customer360/ExecuteResolution/reducer';
import CallbackRequest from './application/V2/Customer360/CallbackRequest/reducer';
import MarkCloseTicket from './application/V2/Customer360/MarkCloseTicket/reducer';
import ParkTicket from './application/V2/Customer360/ParkTicket/reducer';
import GetBookingDropdown from './application/V2/Customer360/GetBookingDropdown/reducer';
import GetSuggestedCategory from './application/V2/Customer360/GetSuggestedCategory/reducer';
import GetBookingLifecycleTimeline from './application/V2/Customer360/GetBookingLifecycleTimeline/reducer';
import GetAdminBookingDetails from './application/V2/Customer360/GetAdminBookingDetails/reducer';
import GetBookingModificationFacilities from './application/V2/Customer360/GetBookingModificationFacilities/reducer';
import CustomerDetailVerify from './application/V2/Customer360/CustomerDetailVerify/reducer';
import ActiveCallerSession from './application/V2/Customer360/ActiveCallerSession/reducer';
import ProfileTabDashboard from './application/V2/Customer360/ProfileTabDashboard/reducer';
import PersonalDetail from './application/V2/Customer360/PersonalDetail/reducer';
import DashboardDevices from './application/V2/Customer360/DashboardDevices/reducer';
import ReactiveUser from './application/V2/Customer360/ReactiveUser/reducer';
import GetMembershipByUser from './application/V2/Customer360/GetMembershipByUser/reducer';
import GetSsoToken from './application/V2/Customer360/GetSsoToken/reducer';
import GetCardByUser from './application/V2/Customer360/GetCardByUser/reducer';
import SupportTicket from './application/V2/Customer360/SupportTicket/reducer';
import RecentActivityProfile from './application/V2/Customer360/ProfileRecentActivity/reducer';
import RecentActivityMembership from './application/V2/Customer360/MembershipRecentActivity/reducer';
import GetBookingLogs from './application/V2/Customer360/GetBookingLogs/reducer';
import ShowHideMembershipCard from './application/V2/Customer360/ShowHideMembershipCard/reducer';
import LogoutCustomer360 from './application/V2/Customer360/LogoutCustomer360/reducer';
import ChangeMembership from './application/V2/Customer360/ChangeExpiry/reducer';
import GetFilter360 from './application/V2/Customer360/GetFilter/reducer';
import SendVerificationLink from './application/V2/Customer360/SendVerificationLink/reducer';
import ResendVerificationLink from './application/V2/Customer360/ResendVerificationLink/reducer';
import GetQuota from './application/V2/Customer360/GetQuota/reducer';
import GetPaymentSummary360 from './application/V2/Customer360/GetPaymentSummary/reducer';
import GetSupportSummary from './application/V2/Customer360/GetSupportSummary/reducer';
import EventTrack from './application/V2/Customer360/EventTrack/reducer';
import CustomerApproval from './application/V2/Customer360/CustomerApproval/reducer';
import GetSupportFilter from './application/V2/Customer360/GetSupportFIlter/reducer';
import SupportFilter from './application/V2/Customer360/SupportFIlter/reducer';
import GetSourceList from './application/V2/TicketManagement/GetSourceList/reducer';
import GetIssueTypes from './application/V2/TicketManagement/GetIssueTypes/reducer';
import GetCategoryTicket from './application/V2/TicketManagement/GetCategoryTicket/reducer';
import GetSubCategoryTicket from './application/V2/TicketManagement/GetSubCategoryTicket/reducer';
import GetPriority from './application/V2/TicketManagement/GetPriority/reducer';
import GetAssignee from './application/V2/TicketManagement/GetAssignee/reducer';
import CreateTicket from './application/V2/TicketManagement/CreateTicket/reducer';
import GetTicketStatus from './application/V2/TicketManagement/GetTicketStatus/reducer';
import GetRecentActivity from './application/V2/TicketManagement/GetRecentActivity/reducer';
import GetTicketAnalytic from './application/V2/TicketManagement/GetTicketAnalytic/reducer';
import GetRequireTypes from './application/V2/TicketManagement/GetRequireTypes/reducer';
import UpdateTicketStatus from './application/V2/TicketManagement/UpdateTicketStatus/reducer';
import UpdateTicketAssign from './application/V2/TicketManagement/UpdateTicketAssign/reducer';
import GetComments from './application/V2/TicketManagement/GetComments/reducer';
import SaveComments from './application/V2/TicketManagement/SaveComments/reducer';
import GetBoard from './application/V2/TicketManagement/GetBoard/reducer';
import GetSlaAssignee from './application/V2/TicketManagement/GetSlaAssignee/reducer';
import CreateBulkMeta from './application/V2/TicketManagement/CreateBulkMeta/reducer';
import GetBrandService from './application/V2/Customer360/GetBrandService/reducer';
import AllocateVoucher from './application/V2/Customer360/AllocateVoucher/reducer';
import SubCategoryMeta from './application/V2/TicketManagement/SubCategoryMeta/reducer';
import RegistrationConfig from './application/V2/Customer360/RegistrationConfig/reducer';
import UserRegister360 from './application/V2/Customer360/UserRegister360/reducer';
import UpdateTicketDetails from './application/V2/TicketManagement/UpdateTicketDetails/reducer';
import VoucherApproval from './application/V2/Customer360/VoucherApproval/reducer';
import ManualRegistrationApproval from './application/V2/Customer360/ManualRegistrationApproval/reducer';
import GetBenefitBooking from './application/V2/Customer360/GetBenefitBooking/reducer';
import AssignCoach from './application/V2/Bookings/Golf/AssignCoach/reducer';
import GetCoachList from './application/V2/Bookings/Golf/GetCoachList/reducer';
import CreateChauffeurV2 from './application/V2/ChauffeurManagement/CreateChauffeur/reducer';
import UpdateChauffeur from './application/V2/ChauffeurManagement/UpdateChauffeur/reducer';
import ResetPasswordChauffeur from './application/V2/ChauffeurManagement/ResetPasswordChauffeur/reducer';
import ChangeChauffeurPassword from './application/V2/ChauffeurManagement/ChangePassword/reducer';
import UpdateChauffeurV2 from './application/V2/ChauffeurManagement/UpdateChauffeurV2/reducer';
import CreateChauffeurV3 from './application/V2/ChauffeurManagementV2/CreateChauffeur/reducer';
import UpdateChauffeurV3 from './application/V2/ChauffeurManagementV2/UpdateChauffeur/reducer';
import CreateVehicle from './application/V2/VehicleManagement/CreateVehicle/reducer';
import UpdateVehicle from './application/V2/VehicleManagement/UpdateVehicle/reducer';
import UpdateVehicleStatus from './application/V2/VehicleManagement/UpdateVehicleStatus/reducer';
import GetVendorCarTypes from './application/V2/VehicleManagement/GetCarTypes/reducer';
import GetVendorCarRegions from './application/V2/VehicleManagement/GetCarRegions/reducer';
import GetVendorChauffeurs from './application/V2/VehicleManagement/GetVendorChauffeurs/reducer';
import GetVendorDashboard from './application/V2/VendorDashboardV3/GetVendorDashboard/reducer';
import GetVendorDashboardMatrix from './application/V2/VendorDashboardV3/GetVendorDashboardMatrix/reducer';
import CreateBooking360 from './application/V2/Customer360/CreateBooking360/reducer';
import ManualBookingApproval from './application/V2/Customer360/ManualBookingApproval/reducer';
import RegistrationBenefit from './application/V2/Customer360/RegistrationBenefit/reducer';
import SendCommunication360 from './application/V2/Customer360/SendCommunication360/reducer';
import UpdateLabels from './application/V2/Customer360/UpdateLabels/reducer';
import GetEndSessionTicket from './application/V2/Customer360/GetEndSessionList/reducer';
import FetchVendorByRegion from './application/V2/AirportClientPricing/GetVendorByRegion/reducer';
import GetCarTypeByVendor from './application/V2/AirportClientPricing/GetCarTypeByVendor/reducer';
import GetVendorConfiguration from './application/V2/AirportClientPricing/GetVendorConfiguration/reducer';
import ExtendTimeSession from './application/V2/Customer360/ExtendTimeSession/reducer';
import GetVendorBookingsAlrajhi from './application/Vendor/VendorBookingsAlrajhi/reducer';
import GetVendorBookingsAlrajhiAccept from './application/Vendor/VendorAcceptBookingAlrajhi/reducer';
import GetVendorBookingsAlrajhiReject from './application/Vendor/VendorRejectBookingAlrajhi/reducer';
import SessionFeedback from './application/V2/Customer360/SessionFeedback/reducer';

import GetProjectCampaign from './application/V2/CampaignManagement/GetCampaignProject/reducer';
import GetCampaignConfiguration from './application/V2/CampaignManagement/GetCampaignConfiguration/reducer';
import GetCampaignsCatalog from './application/V2/CampaignManagement/GetCampaignsCatalog/reducer';
import PauseCampaign from './application/V2/CampaignManagement/PauseCampaign/reducer';
import CreateCampaignManagement from './application/V2/CampaignManagement/CreateCampaignManagement/reducer';
import EditCampaign from './application/V2/CampaignManagement/EditCampaign/reducer';
import CampaignSendForApproval from './application/V2/CampaignManagement/CampaignSendForApproval/reducer';
import CampaignManagementApproval from './application/V2/CampaignManagement/CampaignManagementApproval/reducer';
import MembershipsRequestApproval from './application/V2/CampaignManagement/MembershipsApproval/reducer';

/* ----------------------------------- PROJECT MANAGEMENT ----------------------------------- */
import GetBookingsAnalytics from './application/V2/ProjectManagement/BookingsAnalytics/reducer';
import GetMembershipsAnalytics from './application/V2/ProjectManagement/MembershipsAnalytics/reducer';
import GetUsersAnalytics from './application/V2/ProjectManagement/UsersAnalytics/reducer';
import GetProgramsListData from './application/V2/ProjectManagement/ProgramsList/reducer';
import GetProgramConfigs from './application/V2/ProjectManagement/GetProgramConfigs/reducer';
import GetMembershipsAnalyticsDetails from './application/V2/ProjectManagement/MembershipsAnalyticsDetails/reducer';
import GetUsersAnalyticsDetails from './application/V2/ProjectManagement/UsersAnalyticsDetails/reducer';
import GetBookingsAnalyticsDetails from './application/V2/ProjectManagement/BookingsAnalyticsDetails/reducer';
import GetTicketFilter from './application/V2/TicketManagement/GetTicketFilter/reducer';
import GetProgramsFilterConfigs from './application/V2/ProjectManagement/ProgramFilterConfigs/reducer';
import GetProgramsDetails from './application/V2/ProjectManagement/ProgramDetails/reducer';
import GetSFTPUsersAnalytics from './application/V2/ProjectManagement/GetSftpUserAnalytics/reducer';
import AgentList from './application/V2/Customer360/AgentList/reducer';
import TransferSession from './application/V2/Customer360/TransferSession/reducer';
import OutgoingSession from './application/V2/Customer360/OutgoingSession/reducer';
import IncomingSession from './application/V2/Customer360/IncomingSession/reducer';
import AcceptSessionTransfer from './application/V2/Customer360/AcceptSessionTransfer/reducer';
import RejectSessionTransfer from './application/V2/Customer360/RejectSessionTransfer/reducer';
import UpdateUsername from './application/V2/Customer360/UpdateUserName/reducer';
import VerifyAndSentOtp from './application/V2/Customer360/VerifyAndSentOtp/reducer';
import VerifyOtp from './application/V2/Customer360/VerifyOtp/reducer';
import VerifyEmail from './application/V2/Customer360/VerifyEmail/reducer';
import GetMembershipsBinMonthlyStats from './application/V2/ProjectManagement/GetMembershipsBinMonthlyStats/reducer';
import GetProgramMembershipsStats from './application/V2/ProjectManagement/GetProgramMembershipsStats/reducer';
import SendEmailCommunication from './application/V2/TicketManagement/SendEmailCommunication/reducer';
import ForwardEmailCommunication from './application/V2/TicketManagement/ForwardEmailCommunication/reducer';
import SendWhatsApp from './application/V2/TicketManagement/SendWhatsApp/reducer';
import GetCommunicationTemplate from './application/V2/TicketManagement/GetEmailTemplate/reducer';
import GetWhatsAppTemplate from './application/V2/TicketManagement/GetWhatsAppTemplate/reducer';
import EmailPhoneDraft from './application/V2/Customer360/EmailPhoneDraft/reducer';
import ApprovalProfile360 from './application/V2/Customer360/ApprovalProfile360/reducer';
import LinkCustomer from './application/V2/TicketManagement/LinkCustomer/reducer';
import SaveFilters from './application/V2/TicketManagement/SaveFilters/reducer';
import UserPendingRequestCount from './application/V2/Customer360/UserPendingRequest/reducer';
import GetGolfInventoryType from './application/V2/GolfPricing/GolfInventoryType/reducer';
import CreateGolfInventory from './application/V2/GolfPricing/CreateGolfInventory/reducer';
import GetCommsStats from './application/V2/ProjectManagement/GetCommsStats/reducer';
import GetCommsSummary from './application/V2/ProjectManagement/GetCommsSummary/reducer';

import GetBlockDateList from './application/V2/AirportClientPricing/GetBlockDate/reducer';
import UpdateBlockDate from './application/V2/AirportClientPricing/UpdateBlockDate/reducer';
import BlockUnblockDate from './application/V2/AirportClientPricing/BlockUnblockDate/reducer';
import GetQuotaDetails from './application/V2/Customer360/GetQuotaDetails/reducer';
import GetGmCurrency from './application/V2/GMDashboard/GetGmCurrency/reducer';
import GetGmCountry from './application/V2/GMDashboard/GetCountry/reducer';
import GetGmProjects from './application/V2/GMDashboard/GetProjects/reducer';
import GetReasonForBlockDate from './application/V2/AirportClientPricing/GetReasonForBlockDate/reducer';
import CreateBlockDateGolfPricing from './application/V2/AirportClientPricing/CreateBlockDate/reducer';
import CreateFacilityHoliday from './application/V2/AirportClientPricing/CreateFacilityHoliday/reducer';
import GetFacilityHolidayList from './application/V2/AirportClientPricing/GetFacilityHoliday/reducer';
import UpdateFacilityHoliday from './application/V2/AirportClientPricing/UpdateFacilityHoliday/reducer';
import DeleteFacilityHoliday from './application/V2/AirportClientPricing/DeleteFacilityHoliday/reducer';
import PostDownloadDumpAdminCustomerV2 from './application/V2/DownloadDumpCustomer/reducer';
import V2ClientForgotPassword from './application/V2/V2ClientForgotPassword/reducer';
import ClientLoginV2 from './application/V2/ClientLoginV2/reducer';
import ClientResetPasswordV2 from './application/V2/ResetPassword/reducer';
import ValidateTokenV2 from './application/V2/ValidateToken/reducer';
import ClientPanelAuthentication from './application/V2/ClientPanelUser/ClientPanelAuthentication/reducer';
import SearchClientPanel from './application/V2/SearchClientPanel/reducer';
import LogoutClientPanel from './application/V2/ClientPanelUser/LogoutClientPanel/reducer';
import GetDownloadDumpListCustomer from './application/V2/GetDownloadDumpListCustomer/reducer';
import GetBenefitType from './application/V2/TicketManagement/GetBenefitType/reducer';
import GetPlatform from './application/V2/TicketManagement/GetPlatform/reducer';
import GetServiceType from './application/V2/TicketManagement/GetServiceType/reducer';
import AcknowledgeClosure from './application/V2/Customer360/AcknowledgeClosure/reducer';
import SendChat from './application/V2/Customer360/SendChat/reducer';
import ShowMessage from './application/V2/Customer360/ShowMessage/reducer';
import HideMessage from './application/V2/Customer360/HideMessage/reducer';
import GetUtilityUserDetails from './application/V2/QuotaReversal/GetUtilityUserDetails/reducer';
import GetBookingTypeForTicketManagement from './application/V2/TicketManagement/GetTicketBookingType/reducer';

/* ----------------------------------- PROGRAM MANAGEMENT ----------------------------------- */
import GetNewProgramDetails from './application/V2/ProgramManagement/GetPrograms/reducer';
import CreateNewProgram from './application/V2/ProgramManagement/CreateProgram/reducer';
import UpdateProgramData from './application/V2/ProgramManagement/UpdateProgram/reducer';
import DeleteProgramData from './application/V2/ProgramManagement/DeleteProgram/reducer';
import GenerateMemberships from './application/V2/ProgramManagement/GenerateMemberships/reducer';
import GetProgramEventActivities from './application/V2/ProgramManagement/EventActivities/reducer';
import GetSpocs from './application/V2/ProgramManagement/GetSpocs/reducer';
import GetPresignedUrl from './application/V2/ProgramManagement/GetPresignedUrl/reducer';
import GetMasterConfigs from './application/V2/ProgramManagement/MasterConfigs/reducer';
import GetSchemasByName from './application/V2/ProgramManagement/GetSchemasByName/reducer';
import AcknowledgeUploadedDocument from './application/V2/ProgramManagement/AcknowledgeUploadedDocument/reducer';
import GetListOfPrograms from './application/V2/ProgramManagement/GetListsOfProgram/reducer';
import GetGlobalMetrices from './application/V2/ProgramManagement/GetGlobalMetrices/reducer';
import GetGlobalVerticalMetrices from './application/V2/ProgramManagement/GetGlobalVerticalMetrices/reducer';
import GetVerticalGlobalMetrices from './application/V2/ProgramManagement/GetVerticalGlobalMetrices/reducer';
import GetProgramMetrices from './application/V2/ProgramManagement/GetProgramMetrices/reducer';
import GetProgramVerticalMetrices from './application/V2/ProgramManagement/GetProgramVerticalMetrices/reducer';
import SendForApproval from './application/V2/ProgramManagement/SendForApproval/reducer';
import GetProgramBookingsSummary from './application/V2/ProgramManagement/GetProgramBookingsSummary/reducer';
import GetProgramBinSummary from './application/V2/ProgramManagement/GetProgramBinSummary/reducer';
import GetProgramMembershipsSummary from './application/V2/ProgramManagement/GetProgramMembershipsSummary/reducer';
import GetProgramInventory from './application/V2/ProgramManagement/GetProgramInventory/reducer';

/* ----------------------------------- PROJECT MANAGEMENT - SUPERSET ----------------------------------- */
import SupersetCSATCount from './application/V2/ProjectManagement/Superset/Csat/reducer';
import SupersetProxyLogin from './application/V2/ProjectManagement/Superset/LoginProxy/reducer';
import SupersetCSRFToken from './application/V2/ProjectManagement/Superset/CSRFToken/reducer';
import SupersetCanvasChartList from './application/V2/ProjectManagement/Superset/Canvas/ChartList/reducer';
import SupersetCanvasChartData from './application/V2/ProjectManagement/Superset/Canvas/ChartData/reducer';
import SupersetCanvasLayout from './application/V2/ProjectManagement/Superset/Canvas/Layout/reducer';
import UpdateDashboardConfig from './application/V2/ProjectManagement/Superset/Canvas/DashboardConfig/reducer';
import GetDashboardConfigs from './application/V2/ProjectManagement/Superset/Canvas/GetDashboardConfigs/reducer';
import SupersetFulfillmentCount from './application/V2/ProjectManagement/Superset/Fulfillment/reducer';
import SupersetGrossMarginCount from './application/V2/ProjectManagement/Superset/GrossMargin/reducer';
import SupersetPainMinutesCount from './application/V2/ProjectManagement/Superset/PainMinutes/reducer';
import SupersetProgramsList from './application/V2/ProjectManagement/Superset/ProgramsList/reducer';
import SupersetAirportVendorList from './application/V2/ProjectManagement/Superset/AirportVendorList/reducer';
import SupersetChauffeurLeaderboard from './application/V2/ProjectManagement/Superset/ChauffeurLeaderboard/reducer';
import SupersetProjectWiseTickets from './application/V2/ProjectManagement/Superset/ProjectWiseTickets/reducer';
import SupersetRevenue from './application/V2/ProjectManagement/Superset/Revenue/reducer';
import SupersetTotalBookingsCount from './application/V2/ProjectManagement/Superset/TotalBookings/reducer';
import SupersetVerticalGrossMarginCount from './application/V2/ProjectManagement/Superset/VerticalGrossMargin/reducer';
import SupersetVerticalPainMinutesCount from './application/V2/ProjectManagement/Superset/VerticalPainMinutes/reducer';
import SupersetVerticalTable from './application/V2/ProjectManagement/Superset/VerticalTable/reducer';
import SupersetTotalCsatSubmitted from './application/V2/ProjectManagement/Superset/TotalCSATSubmitted/reducer';
import SupersetTotalCsatInvitesSent from './application/V2/ProjectManagement/Superset/TotalCsatInvitesSent/reducer';
import SupersetCSATScore from './application/V2/ProjectManagement/Superset/CsatScore/reducer';
import SupersetCSATCustomerFeedbacks from './application/V2/ProjectManagement/Superset/CsatCustomerFeedbacks/reducer';
import SupersetVerticallyCSAT from './application/V2/ProjectManagement/Superset/VerticallyCsat/reducer';
import SupersetCSATDissatisfiedData from './application/V2/ProjectManagement/Superset/CsatDissatisfiedData/reducer';
import SupersetCSATSatisfiedData from './application/V2/ProjectManagement/Superset/CsatSatisfiedData/reducer';
import SupersetCsatResponseRate from './application/V2/ProjectManagement/Superset/CsatResponseRate/reducer';
import SupersetServiceWiseSlaPainMinutes from './application/V2/ProgramManagement/ServiceWisePainMinutes/reducer';

/* ----------------------------------- DASHBOARD DETAILS - SUPERSET ----------------------------------- */
import SupersetDashboardDetailsProxyLogin from './application/V2/ProjectManagement/Superset/DashboardDetailsLoginProxy/reducer';
import SupersetDashboardDetailsCSRFToken from './application/V2/ProjectManagement/Superset/DashboardDetailsCSRFToken/reducer';

/* ----------------------------------- PAIN MINUTES DASHBOARD ----------------------------------- */
import PainMinutesDashboardProxyLogin from './application/V2/ProgramManagement/PainMinutesDashboardProxyLogin/reducer';
import PainMinutesDashboardCSRFToken from './application/V2/ProgramManagement/PainMinutesDashboardCSRFToken/reducer';
import Customer360PainMinutes from './application/V2/ProgramManagement/Customer360PainMinutes/reducer';
import SlaPainMinutes from './application/V2/ProgramManagement/SlaPainMinutes/reducer';
import CloudInfraPainMinutes from './application/V2/ProgramManagement/CloudInfraPainMinutes/reducer';
import PaymentFailurePainMinutes from './application/V2/ProgramManagement/PaymentFailurePainMinutes/reducer';

import SupersetVerticalTotalBookingsCount from './application/V2/ProjectManagement/Superset/VerticalTotalBookings/reducer';
import SupersetAINAContribution from './application/V2/ProjectManagement/Superset/AinaContribution/reducer';
import SaasSaveDraft from './application/V2/GmInventoryPricing/SaasSaveDraft/reducer';
import SaasConfirm from './application/V2/GmInventoryPricing/SaasConfirm/reducer';
import EventsSaveDraft from './application/V2/GmInventoryPricing/EventsSaveDraft/reducer';
import EventsConfirm from './application/V2/GmInventoryPricing/EventsConfirm/reducer';
import DigitalSaveDraft from './application/V2/GmInventoryPricing/DigitalSaveDraft/reducer';
import DigitalConfirm from './application/V2/GmInventoryPricing/DigitalConfirm/reducer';
import GmPriceApproval from './application/V2/GmInventoryPricing/GmPriceApproval/reducer';
import GetGmCampaigns from './application/V2/GmInventoryPricing/GetGmCampaigns/reducer';

/* ----------------------------------- CLIENT SUPERSET DASHBOARD ----------------------------------- */
import ClientTotalActiveMemberships from './application/V2/ProjectManagement/Superset/ClientSuperset/TotalActiveMemberships/reducer';
import ClientTotalBookings from './application/V2/ProjectManagement/Superset/ClientSuperset/TotalBookings/reducer';
import ClientTotalConfirmedBookings from './application/V2/ProjectManagement/Superset/ClientSuperset/TotalConfirmedBookings/reducer';
import ClientTotalExpiredMemberships from './application/V2/ProjectManagement/Superset/ClientSuperset/TotalExpiredMemberships/reducer';
import ClientTotalUsers from './application/V2/ProjectManagement/Superset/ClientSuperset/TotalUsers/reducer';
import ClientVerticalWiseBookingsData from './application/V2/ProjectManagement/Superset/ClientSuperset/VerticalWiseBookingsData/reducer';
import GetUtilityRequestCardStates from './application/V2/QuotaReversal/GetUtilityCardStates/reducer';
import GetUtilityRequestIssueTypes from './application/V2/QuotaReversal/GetUtilityIssueTypes/reducer';
import UploadUtilityAttachment from './application/V2/QuotaReversal/UploadUtilityAttachment/reducer';
import GetUtilityRequestProjects from './application/V2/QuotaReversal/GetUtilityProjects/reducer';
import GetUtilityBookingDetails from './application/V2/QuotaReversal/GetUtilityBookingDetails/reducer';
import CreateUtilityRequest from './application/V2/QuotaReversal/CreateUtilityRequest/reducer';
import ValidateUtilityAttachments from './application/V2/QuotaReversal/ValidateUtilityAttachments/reducer';
import ApprovalActionUtilityRequest from './application/V2/QuotaReversal/ApprovalActionUtilityRequest/reducer';
import GetUtilityRequestDetails from './application/V2/QuotaReversal/GetUtilityRequestDetails/reducer';
import DownloadUtilitySampleExcel from './application/V2/QuotaReversal/DownloadUtilitySampleExcel/reducer';
import DownloadManualBookingSampleExcel from './application/V2/QuotaReversal/DownloadManualBookingSampleExcel/reducer';
import GetManualFacilities from './application/V2/QuotaReversal/GetManualFacilities/reducer';
import GetManualGolfCoaches from './application/V2/QuotaReversal/GetManualGolfCoaches/reducer';
import SaveManualBookingDraft from './application/V2/QuotaReversal/SaveManualBookingDraft/reducer';
import SubmitManualBookingApproval from './application/V2/QuotaReversal/SubmitManualBookingApproval/reducer';
import DownloadManualBookingSummaryExcel from './application/V2/QuotaReversal/DownloadManualBookingSummaryExcel/reducer';
import ValidateJiraTicket from './application/V2/QuotaReversal/ValidateJiraTicket/reducer';
import GetSubCategoryResolutions from './application/V2/TicketManagement/GetSubCategoryResolutions/reducer';
import GetGlobalVendors from './application/V2/TicketManagement/GetGlobalVendors/reducer';

/* ----------------------------------- FAB SURGE ----------------------------------- */

// CAMPAIGN
import ListCompaign from './application/V2/FabSurge/Compaign/ListCompaign/reducer';
import CreateSurgeCompaign from './application/V2/FabSurge/Compaign/CreateSurgeCompaign/reducer';
import UpdateSurgeCompaign from './application/V2/FabSurge/Compaign/UpdateSurgeCompaign/reducer';
import ExecuteSurgeCompaign from './application/V2/FabSurge/Compaign/ExecuteSurgeCompaign/reducer';
import GetCompaignDetails from './application/V2/FabSurge/Compaign/GetCompaignDetails/reducer';
import GetCompaignSummary from './application/V2/FabSurge/Compaign/GetCompaignSummary/reducer';
import GetCompaignMetaDataConfig from './application/V2/FabSurge/Compaign/GetCompaignMetaData/reducer';
import GetRuleMetaDataConfig from './application/V2/FabSurge/Compaign/GetRuleMetaConfig/reducer';
import CreateCampaignRule from './application/V2/FabSurge/Compaign/CreateCampaignRule/reducer';
import GetCampaignRules from './application/V2/FabSurge/Compaign/GetCampaignRules/reducer';
import CreateCampaignEffect from './application/V2/FabSurge/Compaign/CreateCampaignEffect/reducer';
import GetCampaignEffects from './application/V2/FabSurge/Compaign/GetCampaignEffects/reducer';
import ApproveSurgeCompaign from './application/V2/FabSurge/Compaign/ApproveCompaign/reducer';

// RULES
import ListRules from './application/V2/FabSurge/Rules/ListRules/reducer';
import GetRulesDetails from './application/V2/FabSurge/Rules/GetRuleDetails/reducer';

// TEMPLATE
import GetSurgeTemplate from './application/V2/FabSurge/Template/GetSurgeTemplate/reducer';
import CreateSurgeTemplate from './application/V2/FabSurge/Template/CreateSurgeTemplate/reducer';
import GetSurgeTemplateDetails from './application/V2/FabSurge/Template/GetSurgeTemplateDetails/reducer';
import GetTemplateById from './application/V2/FabSurge/Template/GetTemplateById/reducer';
import GetTemplateSchemaDiff from './application/V2/FabSurge/Template/GetTemplateSchemaDiff/reducer';
import GetSurgeTemplateVerison from './application/V2/FabSurge/Template/GetSurgeTemplateVersion/reducer';
import ApproveSurgeTemplate from './application/V2/FabSurge/Template/ApproveTemplate/reducer';
import ApproveSurgeFileUpload from './application/V2/FabSurge/DataUpload/ApproveFileUpload/reducer';

// USER MANAGEMENT
import GetFabUserList from './application/V2/FabSurge/UserManagement/GetUserList/reducer';
import GetFabUserDetails from './application/V2/FabSurge/UserManagement/GetUserDetails/reducer';
import GetFabUserSummary from './application/V2/FabSurge/UserManagement/GetUserSummary/reducer';
import GetFabUserRole from './application/V2/FabSurge/UserManagement/GetUserRole/reducer';
import CreateFabUser from './application/V2/FabSurge/UserManagement/CreateUser/reducer';
import UpdateExistingFabUser from './application/V2/FabSurge/UserManagement/UpdateExistingUser/reducer';
import UpdateFabUserRole from './application/V2/FabSurge/UserManagement/UpdateUserRole/reducer';
import UpdateFabUserStatus from './application/V2/FabSurge/UserManagement/ActiveDisableUsers/reducer';

// LEDGER
import GetLedgerList from './application/V2/FabSurge/Ledger/GetLedger/reducer';
import GetLedgerDetails from './application/V2/FabSurge/Ledger/GetLedgerDetails/reducer';
import GetLedgerFilter from './application/V2/FabSurge/Ledger/GetLedgerFilter/reducer';
import GetLedgerSummary from './application/V2/FabSurge/Ledger/GetLedgerSummary/reducer';

// DATA UPLOAD MANAGEMENT
import GetFileList from './application/V2/FabSurge/DataUpload/GetFileList/reducer';
import GetFileDetails from './application/V2/FabSurge/DataUpload/GetFileDetails/reducer';
import GetFieldRegistry from './application/V2/FabSurge/DataUpload/GetFieldRegistry/reducer';
import CreateFieldRegistry from './application/V2/FabSurge/DataUpload/CreateFieldRegistry/reducer';
import UpdateFieldRegistry from './application/V2/FabSurge/DataUpload/UpdateFieldRegistry/reducer';
import DeleteFieldRegistry from './application/V2/FabSurge/DataUpload/DeleteFieldRegistry/reducer';
import GetUploadSurgeType from './application/V2/FabSurge/DataUpload/GetUploadSurgeType/reducer';
import UploadSurgeFile from './application/V2/FabSurge/DataUpload/UploadDataFile/reducer';
import DownloadSurgeSampleFile from './application/V2/FabSurge/DataUpload/DownloadSurgeSample/reducer';
import DownloadInvalidFiles from './application/V2/FabSurge/DataUpload/DownloadInvalidFiles/reducer';
import DownloadSurgeLogs from './application/V2/FabSurge/DataUpload/DownloadSurgeLogs/reducer';

// CUSTOMER 360
import GetCardFabSurge from './application/V2/Customer360/GetCardFabSurge/reducer';
import GetCashbackStatement from './application/V2/Customer360/GetCashbackStatement/reducer';
import GetCommulativeEarning from './application/V2/Customer360/GetCommulativeEarning/reducer';

import GetReasonSurge from './application/V2/FabSurge/GetReason/reducer';

const rootReducer = combineReducers({
  // public
  Layout,
  Login,
  Account,
  ForgetPassword,
  Profile,
  Calendar,
  chat,
  Projects,
  Ecommerce,
  Tasks,
  changeNumber,
  Crypto,
  Tickets,
  Crm,
  Invoice,
  Mailbox,
  DeleteFile,

  /* ---------------------------- COMMON API'S ---------------------------- */
  Countries,
  Regions,
  SubRegions,
  Airports,
  BookingTypes,

  MainAreaLoader,
  FullScreenLoader,

  AllProjects,
  AllGolfCourses,
  UserLogin,
  UserLogout,
  SendMail,
  GetParentCategory,
  GetRedemptionType,
  PermissionsByProjectId,

  /* ---------------------------- DASHBOARD ---------------------------- */
  GetSurgeReport,
  GetUsersList,
  GetUserPoints,
  GetUserBookings,
  GetMisReport,

  /* ---------------------------- SUPPLY STORE ---------------------------- */
  GetUploadsInfo,

  // Category
  CreateCategory,
  UpdateCategory,
  GetCategory,

  // Location
  CreateLocation,
  UpdateLocation,
  GetLocation,

  // Partner
  CreatePartner,
  UpdatePartner,
  GetPartners,

  // Service
  CreateService,
  UpdateService,
  GetService,

  /* ---------------------------- COUPON MANAGEMENT ---------------------------- */
  GetCoupon,
  GetCoupons,
  GetCouponCategory,
  GetCouponFacility,
  GetCouponPartner,
  GetCouponProject,
  GetCouponServices,
  GetCouponAssignedStatusList,
  GetCouponUploadedByList,
  PostCoupons,
  AssignCoupon,
  UpdateCoupon,
  UploadStaticCoupon,
  GetStaticCoupons,
  UpdateStaticCoupon,

  /* ---------------------------- BOOKING MANAGEMENT ---------------------------- */
  Bookings,
  UpdateBooking,
  ResendMail,
  VendorsList,
  GetVendorByBooking,
  ViewFile,

  /* ---------------------------- USER MANAGEMENT ---------------------------- */
  AllRights,
  CreateUser,
  ProgramUsers,
  MembershipDetails,
  CardDetails,
  BulkUsers,
  UserCards,
  UpdateUserCard,
  Memberships,
  UpdateCustomer,
  GetUserDetails,
  ValidateUser,

  /* ---------------------------- DUPLICATE CARD MANAGEMENT ---------------------------- */
  DuplicateCards,

  /* ---------------------------- BENEFIT MANAGEMENT ---------------------------- */
  BenefitGroups,
  BenefitPack,
  Clients,
  CreateBenefitPack,
  BenefitPackInfo,
  UpdateBenefitPack,
  CreateInventoryQuota,
  GetInventoryQuota,
  GetWorkflowsList,

  /* ---------------------------- DOWNLOADS ---------------------------- */
  DownloadsList,
  DownloadDump,

  /* ---------------------------- BLOCK DATE ---------------------------- */
  CreateBlockDate,
  ApprovalBlockDate,
  ApprovalFacilityHoliday,
  BlockedDatesList,
  GetServiceOnFacility,
  DeactivateBlockDate,

  /* ---------------------------- RULE MANAGEMENT ---------------------------- */
  CreateExpenditureRule,
  ExpenditureRulesList,
  UpdateExpenditureRule,
  DeleteExpenditureRule,

  CreateEventRules,
  CreateEventRulesWithUserIds,
  CreateEventRulesBenefitGroupId,
  EventRulesList,
  UpdateEventRule,
  DeleteEventRule,

  CreateServiceWorth,
  ServiceWorthList,
  UpdateServiceWorth,
  DeleteServiceWorth,

  /* ---------------------------- GOLF ADMIN ---------------------------- */
  GetGolfCourseFormatById,
  GetGolfCourseFormats,
  deleteGolfCourseFormatById,
  GetGolfCourseUnavailable,
  createGolfCourseSlot,
  GetGolfCourses,
  GolfCourseSlots,
  DownloadExcelReport,
  DisableGolfCourseUnavailability,
  createGolfCourseUnavailability,
  UpdateGolfCourseSlots,

  /* ---------------------------- USER MANAGEMENT ---------------------------- */
  Users,
  Permissions,
  UpdatePermissions,

  /* ---------------------------- PROJECT MANAGEMENT ---------------------------- */
  CreateProject,
  ProjectsList,
  GetPaymentGateways,
  GetPaymentsList,
  CreatePayment,
  UpdatePayment,
  BinsList,
  UpdateBins,
  CreateBin,
  PaymentLogs,
  CreateClient,
  CreateParentProject,
  ParentProjects,
  UpdateParentProject,
  UpdateProject,
  UpdateClient,

  /* ---------------------------- CONFIG STORE MANAGEMENT ---------------------------- */
  CreateBenefitGroup,
  CreateBenefitGroupItems,
  CreateBenefitGroupCategory,
  BenefitGroupCategories,
  GetBenefitGroups,
  GetServicesInBenefitItem,
  UpdateBenefitGroup,
  UpdateBenefitGroupItems,
  GetBenefitGroupItemsList,
  BenefitItemsList,
  UpdateBenefitItems,

  /* ---------------------------- CUSTOMER DATA MANAGEMENT ---------------------------- */
  CustomerUploadsInfo,
  ClientsCustomer,
  UpdateClientsCustomer,

  // CAMPAIGN
  CreateCampaign,
  GetCampaigns,
  UpdateCampaign,

  // RULES
  CreateRule,
  GetRules,
  UpdateRule,
  DeleteRule,

  // EVENTS
  CreateEvent,
  GetEvents,
  UpdateEvent,
  DeleteEvent,

  // ATTRIBUTES
  CreateAttribute,
  GetAttributes,
  UpdateAttribute,
  DeleteAttribute,

  // WALLETS
  GetWallets,

  /* ----------------------------------- DATA POOL ----------------------------------- */
  FilesSummary,
  FileSummary,
  UploadFile,

  /* ----------------------------------- DATA INTEGRATION ----------------------------------- */
  IntegrationData,
  UpdateIntegrationData,
  CreateIntegrationData,

  /* ---------------------------- COMMUNICATION ---------------------------- */
  CreateTemplate,
  GetTemplates,
  UpdateTemplate,
  CreateComsConfig,
  UpdateComsConfig,
  GetComsConfig,
  GetComsEvents,
  GetTemplateDetails,
  CreateComsChannelConfig,
  UpdateComsChannelConfig,
  GetComsChannelConfig,
  GetComsBenefit,
  GetVariables,
  SendCommunication,

  /* ----------------------------------- DASHBOARD ----------------------------------- */
  GetBookingSummary,

  /* ----------------------------------- THRIWE PRIME BOOKING ----------------------------------- */
  ThriwePrimeBookingList,

  /* ----------------------------------- REPORTS MANAGEMENT ----------------------------------- */
  GetCommsReport,

  /* ----------------------------------- VENDOR PANEL MANAGEMENT ----------------------------------- */
  GetVendors,
  CreateVendor,
  GetBenefitDomains,
  CreateVendorAgent,

  /* ----------------------------------- UPDATE MEMBERSHIP ----------------------------------- */
  UpdateMembership,

  /* ----------------------------------- CLIENT PANEL MANAGEMENT ----------------------------------- */
  ClientLogin,
  ValidateToken,
  ValidateTokenV2,
  ClientForgotPassword,
  V2ClientForgotPassword,
  ClientResetPassword,
  ClientResetPasswordV2,
  CreateBooking,
  UpdateProfile,
  GetMembershipsData,
  GetBenefitItems,
  GetBinsList,
  CreateClientUser,
  GetClientHistoryList,
  GetClientBenefitConfig,
  GetClientAirport,
  ClientDownloadsList,
  ClientDownloadDump,
  SendEmail,
  ClientRegions,
  GetBusiness,
  UpdateBusiness,
  GetQuestionAnswer,
  GetPost,
  UpdatePost,
  GetOffer,
  UpdateOffer,
  AskQuestion,
  GetAnnouncements,
  CreateAnnoucement,
  GetPostTypes,
  PostImage,
  AdibSurgeReport,
  GetAdibMonthlySummary,
  GetAdibPartnersMonthlySummary,
  GetClientCustomers,
  DownloadBookingsDump,
  DownloadBookingsInfo,
  DownloadAdibBookingDump,
  ClientDownloadDumpADIB,
  GetPostSetting,
  UpdatePostSetting,
  UpdateUserSetting,
  GetClientUser,
  GetClientRoleForUser,
  GetClientRole,
  UpdateClientRole,
  CreateAdibClient,
  GetClientPermissionForUser,
  UpdateUserStatus,
  GetAdibDashboard,
  DownloadUserLogs,
  DownloadUserReport,
  GetUserDownloads,

  /* ----------------------------------- VENDOR ----------------------------------- */
  VendorLogin,
  GetVendorsList,
  GetVendorsDashboardData,
  GetVendorBookings,
  VendorDownloadDump,
  VendorDownloadsList,
  VendorUpdateBooking,
  VendorOtpValidate,
  VendorResendOtp,
  VendorGenerateQr,
  GetUserProfile,
  VendorBookingUpdate,

  /* ----------------------------------- AIRPORT TRANSFER MANUAL BOOKING ----------------------------------- */
  GetAdminMembershipsData,
  GetBenefitCategory,
  GetUserCardData,
  GetMembershipQuota,
  CreateManualBooking,
  GetAdminBenefitItems,
  CreateUploadTicket,

  /* ----------------------------------- GM REPORT ----------------------------------- */
  GetFileTypes,
  GetFileTypesConfig,
  GetRecordData,
  GetTrackerData,
  UploadConfigExcel,
  DownloadExcel,
  UpdateRecordData,
  PublishRecord,
  ApproveRejectRecords,
  SendApprovalMail,
  DeleteTrackerRecord,
  GetClientPrice,
  GetAmenitiesDetails,
  GetPriceDetails,
  PublishDataWithAuth,
  PricePreview,
  UploadAttachment,
  DeleteAttachment,
  GetReconDetails,
  GetGmReport,
  GetReconPreview,

  /* ----------------------------------- CLIENT PROJECT UTILTIES ----------------------------------- */
  GetProjectUtility,

  /* ----------------------------------- BOOKING TYPE V2 ----------------------------------- */
  BookingsV2,
  CancelBookingV2,
  ConfirmBookingV2,
  ProccessBookingV2,
  CompleteBookingV2,
  CancelBookingGolf,
  ConfirmBookingGolf,
  DownloadDumpV2,
  DwonloadListV2,

  /* ----------------------------------- PERMISSION CHECKER ----------------------------------- */
  PermissionChecker,
  UpdatePermissionRequest,
  BookingsSearch,

  /* ----------------------------------- SURGE V2 ----------------------------------- */
  // RULES
  CreateSurgeRule,
  CreateSurgeWorkflow,
  GetSurgeRulesList,
  ListSurgeRuleTables,

  //REFERRAL
  GetReferral,
  ValidateReferral,
  GetLedger,

  // EVENTS
  ListSurgeEvents,

  // EFFECTS
  ListSurgeEffects,
  GetUserRegistration,
  UserRegistration,

  // VOUCHER
  GetVoucherBooking,
  GetVoucherBookingDetails,
  ValidateVoucher,
  GetSampleFile,

  GetAnnouncementForGlobe,
  CreateAnnouncementForGlobeToyota,
  UpdateAnnouncementForGlobeToyota,
  GetTemplateList,
  TemplateDetails,
  RuleDetails,
  CreateTemplateWorkflow,
  CreateTemplateMapping,
  GetRuleDashboard,
  GetDownloadLedgers,
  GetDownloadVouchers,
  getDownloadReferrals,

  ChaufferAssign,

  UserLoginV2,
  UserToken,
  VendorLoginV2,
  AssignChauffeur,
  BookingAssignToMe,
  AssignVendor,
  CancelBookingByVendor,
  ConfirmBookingByVendor,
  CreateChauffeur,
  GetChauffersList,
  GetCarsListOfVendor,
  GetVendorsListData,
  GetBookingsList,
  GetBookingDetails,
  GetDigitalOffers,
  GetDigitalAuthMethods,
  GetDigitalCardStates,
  CreateOutlet,
  GetOutlets,
  GetOutletDetails,
  GetOutletStatusCounts,
  UpdateOutlet,
  GetOutletFilters,
  VerifyCoupon,
  GetFiltersList,
  GetFilterValues,
  CancellationRemarksForVendor,
  AssignVendorRemarksList,
  NudgeDriver,
  GetAvailableVehicles,
  ChangeVehicle,
  BookingType,
  ChangeActivity,
  V2Dashboard,
  UserRoles,
  CancelBookingByAdmin,
  FetchActivity,
  GetDashboardConfiguration,
  GetCardSummary,
  GetUtilityRequestCardStates,
  GetUtilityRequestIssueTypes,
  UploadUtilityAttachment,
  GetUtilityRequestProjects,
  GetUtilityBookingDetails,
  CreateUtilityRequest,
  ValidateUtilityAttachments,
  ApprovalActionUtilityRequest,
  GetUtilityRequestDetails,
  DownloadUtilitySampleExcel,
  DownloadManualBookingSampleExcel,
  GetManualFacilities,
  GetManualGolfCoaches,
  SaveManualBookingDraft,
  SubmitManualBookingApproval,
  DownloadManualBookingSummaryExcel,
  ValidateJiraTicket,
  GetUtilityUserDetails,
  GetBookingTypeForGlobalSearch,
  GetBookingGlobalSearch,
  ShowModifyField,
  ModifyBooking,
  ApprovalActionBooking,
  RemarkStatusDetails,
  GetActionByStatus,
  GetReasonByActions,
  AddReason,
  UpdateReason,
  CompleteBooking,
  RaiseDispute,
  GetBookingDumpTypeList,
  PostDownloadDumpAdminV2,
  GetDownloadDumpList,
  BulkBookingConfirmationByVendor,

  GetAirportsBasedOnConfig,
  getAutoCompleteLocation,
  CreateAirportTransferBooking,
  CreateGuestUser,
  GetBookingSummaryData,
  GetGuestUsers,
  GetPaymentSummary,
  GetValidateFlightDetails,
  GetRecentSearches,
  UpdateGuestUser,
  GetValidateLocation,
  ValidateOTP,
  ResendOTP,
  GetNotificationBooking,
  GetNotificationStatus,
  SendNotificationByAdmin,
  GetSidebarConfiguration,
  GetRejectSlotOptions,
  RejectSlot,
  MarkNoShow,
  AddManualPricing,
  CreateSpinGame,
  GetBenefitsGamification,
  GetBenefitsGamificationPoint,
  GetGamificationList,
  UpdateGameStatus,
  GetFeedbackList,
  CreateQuizGame,
  GetTrendingUser,
  GetBenefitGroup,
  SuggestGolf,
  AddSuggestGolf,
  CompleteBookingGolf,
  GetRejectSlotOptionsV2,

  /* ----------------------------------- Airport Transfer Client Pricing ----------------------------------- */
  GetClientV2,
  GetClientDetailsV2,
  GetProjectV2,
  GetBenefitAndBenefitGroup,
  GetCoordinates,
  GetCarType,
  GetVendorDetails,
  GetInventoryView,
  CreateClientV2,
  CreateZonesV2,
  CreateVendorV2,
  ChangeVendorPassword,
  CreateAirportV2,
  UpdateClientV2,
  UpdateZonesV2,
  UpdateVendorV2,
  UpdateVendorStatusV2,
  UpdateAirportV2,
  SaveDraftConfiguration,
  UpdateDraftConfiguration,
  DownloadPriceType,
  UploadPriceType,
  GetOnboardingConfiguration,
  ApprovalActionConfiguration,
  GetLiveConfig,
  PublishConfiguration,
  PublishApproval,
  ValidateZone,
  GetPolygonRegion,
  RevokeConfiguration,
  GetVendorList,
  GetVendorBookingsAlrajhi,
  GetVendorBookingsAlrajhiAccept,
  GetVendorBookingsAlrajhiReject,
  GetProjectList,
  UploadCancelationFile,
  CancelledWithVendor,
  ViewPricing,
  DownloadPricing,
  VendorUnAssigned,
  GetLiveBenefitGroup,

  // Customer 360
  CustomerVerification,
  CustomerSession,
  CustomerUserDetail,
  GetCustomerIssues,
  GetCustomerResolutions,
  GetIssueLog,
  ExecuteResolution,
  CallbackRequest,
  MarkCloseTicket,
  ParkTicket,
  GetBookingDropdown,
  GetSuggestedCategory,
  GetBookingLifecycleTimeline,
  GetAdminBookingDetails,
  GetBookingModificationFacilities,
  CustomerDetailVerify,
  ActiveCallerSession,
  ProfileTabDashboard,
  SupportTicket,
  RecentActivityProfile,
  RecentActivityMembership,
  PersonalDetail,
  DashboardDevices,
  ReactiveUser,
  GetMembershipByUser,
  GetCardByUser,
  GetSsoToken,
  GetBookingLogs,
  GetBenefitBooking,
  ShowHideMembershipCard,
  LogoutCustomer360,
  ChangeMembership,
  GetFilter360,
  SendVerificationLink,
  ResendVerificationLink,
  GetQuota,
  GetPaymentSummary360,
  GetSupportSummary,
  EventTrack,
  CustomerApproval,
  GetSupportFilter,
  SupportFilter,
  SessionFeedback,
  AgentList,
  TransferSession,
  OutgoingSession,
  IncomingSession,
  AcceptSessionTransfer,
  RejectSessionTransfer,
  UpdateUsername,
  VerifyAndSentOtp,
  VerifyOtp,
  VerifyEmail,
  EmailPhoneDraft,
  ApprovalProfile360,
  GetQuotaDetails,
  ShowMessage,
  HideMessage,

  // Ticket Management
  GetSourceList,
  GetBookingTypeForTicketManagement,
  GetIssueTypes,
  GetCategoryTicket,
  GetSubCategoryTicket,
  GetPriority,
  GetAssignee,
  CreateTicket,
  GetTicketStatus,
  GetRecentActivity,
  GetTicketAnalytic,
  GetRequireTypes,
  UpdateTicketStatus,
  UpdateTicketAssign,
  UpdateTicketDetails,
  GetSubCategoryResolutions,
  GetGlobalVendors,
  GetComments,
  SaveComments,
  GetBoard,
  GetSlaAssignee,
  CreateBulkMeta,
  GetBrandService,
  AllocateVoucher,
  SubCategoryMeta,
  RegistrationConfig,
  UserRegister360,
  VoucherApproval,
  ManualRegistrationApproval,
  AssignCoach,
  GetCoachList,
  GetTicketFilter,
  SendEmailCommunication,
  ForwardEmailCommunication,
  SendWhatsApp,
  GetCommunicationTemplate,
  GetWhatsAppTemplate,
  LinkCustomer,
  SaveFilters,

  GetBenefitType,
  GetPlatform,
  GetServiceType,
  AcknowledgeClosure,
  SendChat,

  CreateChauffeurV2,
  UpdateChauffeur,
  ResetPasswordChauffeur,
  ChangeChauffeurPassword,
  UpdateChauffeurV2,
  CreateChauffeurV3,
  UpdateChauffeurV3,
  CreateVehicle,
  UpdateVehicle,
  UpdateVehicleStatus,
  GetVendorCarTypes,
  GetVendorCarRegions,
  GetVendorChauffeurs,
  GetVendorDashboard,
  GetVendorDashboardMatrix,
  CreateBooking360,
  ManualBookingApproval,
  RegistrationBenefit,
  SendCommunication360,
  UpdateLabels,
  GetEndSessionTicket,
  FetchVendorByRegion,
  GetCarTypeByVendor,
  GetVendorConfiguration,
  ExtendTimeSession,

  //CAMPAIGN MANAGEMENT
  GetProjectCampaign,
  GetCampaignConfiguration,
  GetCampaignsCatalog,
  PauseCampaign,
  CreateCampaignManagement,
  EditCampaign,
  CampaignSendForApproval,
  CampaignManagementApproval,
  MembershipsRequestApproval,

  // PROJECT MANAGEMENT V2
  GetBookingsAnalytics,
  GetBookingsAnalyticsDetails,
  GetMembershipsAnalytics,
  GetMembershipsAnalyticsDetails,
  GetUsersAnalytics,
  GetUsersAnalyticsDetails,
  GetProgramsListData,
  GetProgramConfigs,
  GetProgramsFilterConfigs,
  GetProgramsDetails,
  GetSFTPUsersAnalytics,
  GetMembershipsBinMonthlyStats,
  GetProgramMembershipsStats,
  UserPendingRequestCount,
  GetGolfInventoryType,
  CreateGolfInventory,
  GetCommsStats,
  GetCommsSummary,

  // PRICING
  GetBlockDateList,
  CreateBlockDateGolfPricing,
  UpdateBlockDate,
  BlockUnblockDate,
  CreateFacilityHoliday,
  GetFacilityHolidayList,
  UpdateFacilityHoliday,
  DeleteFacilityHoliday,
  SaasSaveDraft,
  SaasConfirm,
  EventsSaveDraft,
  EventsConfirm,
  DigitalSaveDraft,
  DigitalConfirm,
  GmPriceApproval,
  GetGmCampaigns,

  //GM Dashboard
  GetGmCurrency,
  GetGmCountry,
  GetGmProjects,
  GetReasonForBlockDate,

  //CLIENT PANEL AUTHENTICATION
  ClientPanelAuthentication,
  SearchClientPanel,
  ClientLoginV2,
  LogoutClientPanel,
  GetDownloadDumpListCustomer,
  PostDownloadDumpAdminCustomerV2,

  /* ----------------------------------- PROGRAM MANAGEMENT ----------------------------------- */
  GetNewProgramDetails,
  CreateNewProgram,
  UpdateProgramData,
  DeleteProgramData,
  GetProgramEventActivities,
  GenerateMemberships,
  GetSpocs,
  GetPresignedUrl,
  GetMasterConfigs,
  GetSchemasByName,
  AcknowledgeUploadedDocument,
  GetListOfPrograms,
  GetGlobalMetrices,
  GetGlobalVerticalMetrices,
  GetVerticalGlobalMetrices,
  GetProgramMetrices,
  GetProgramVerticalMetrices,
  SendForApproval,
  GetProgramMembershipsSummary,
  GetProgramBinSummary,
  GetProgramBookingsSummary,
  GetProgramInventory,

  /* ----------------------------------- PROGRAM MANAGEMENT - SUPERSET ----------------------------------- */
  SupersetCSATCount,
  SupersetProxyLogin,
  SupersetCSRFToken,
  SupersetCanvasChartList,
  SupersetCanvasChartData,
  SupersetCanvasLayout,
  UpdateDashboardConfig,
  GetDashboardConfigs,
  SupersetFulfillmentCount,
  SupersetGrossMarginCount,
  SupersetPainMinutesCount,
  SupersetProgramsList,
  SupersetAirportVendorList,
  SupersetChauffeurLeaderboard,
  SupersetProjectWiseTickets,
  SupersetRevenue,
  SupersetTotalBookingsCount,
  SupersetVerticalGrossMarginCount,
  SupersetVerticalPainMinutesCount,
  SupersetVerticalTable,
  SupersetVerticalTotalBookingsCount,
  SupersetAINAContribution,
  SupersetCSATScore,
  SupersetTotalCsatInvitesSent,
  SupersetTotalCsatSubmitted,
  SupersetVerticallyCSAT,
  SupersetCSATCustomerFeedbacks,
  SupersetCSATSatisfiedData,
  SupersetCSATDissatisfiedData,
  SupersetCsatResponseRate,
  SupersetServiceWiseSlaPainMinutes,

  /* ----------------------------------- DASHBOARD DETAILS - SUPERSET ----------------------------------- */
  SupersetDashboardDetailsProxyLogin,
  SupersetDashboardDetailsCSRFToken,

  /* ----------------------------------- PAIN MINUTES DASHBOARD ----------------------------------- */
  PainMinutesDashboardProxyLogin,
  PainMinutesDashboardCSRFToken,
  Customer360PainMinutes,
  SlaPainMinutes,
  CloudInfraPainMinutes,
  PaymentFailurePainMinutes,

  /* ----------------------------------- CLIENT SUPERSET DASHBOARD ----------------------------------- */
  ClientTotalActiveMemberships,
  ClientTotalBookings,
  ClientTotalConfirmedBookings,
  ClientTotalExpiredMemberships,
  ClientTotalUsers,
  ClientVerticalWiseBookingsData,

  /* ----------------------------------- FAB SURGE ----------------------------------- */
  // CAMPAIGN
  ListCompaign,
  CreateSurgeCompaign,
  UpdateSurgeCompaign,
  ExecuteSurgeCompaign,
  GetCompaignDetails,
  GetCompaignSummary,
  GetCompaignMetaDataConfig,
  GetRuleMetaDataConfig,
  CreateCampaignRule,
  GetCampaignRules,
  CreateCampaignEffect,
  GetCampaignEffects,
  ApproveSurgeCompaign,

  // RULES
  ListRules,
  GetRulesDetails,

  // TEMPLATE
  GetSurgeTemplate,
  CreateSurgeTemplate,
  GetSurgeTemplateDetails,
  GetTemplateById,
  GetTemplateSchemaDiff,
  GetSurgeTemplateVerison,
  ApproveSurgeTemplate,
  ApproveSurgeFileUpload,

  // USER MANAGEMENT
  GetFabUserList,
  GetFabUserDetails,
  GetFabUserSummary,
  GetFabUserRole,
  CreateFabUser,
  UpdateExistingFabUser,
  UpdateFabUserRole,
  UpdateFabUserStatus,

  // LEDGER
  GetLedgerList,
  GetLedgerDetails,
  GetLedgerFilter,
  GetLedgerSummary,

  // DATA UPLOAD MANAGEMENT
  GetFileList,
  GetFileDetails,
  GetFieldRegistry,
  CreateFieldRegistry,
  UpdateFieldRegistry,
  DeleteFieldRegistry,
  GetUploadSurgeType,
  UploadSurgeFile,
  DownloadSurgeSampleFile,
  DownloadInvalidFiles,
  DownloadSurgeLogs,

  // CUSTOMER 360
  GetCardFabSurge,
  GetCashbackStatement,
  GetCommulativeEarning,

  GetReasonSurge,
});

export default rootReducer;
